<template>
	<v-layout>
		<v-navigation-drawer v-model="isModalOpen" temporary location="right" width="420" class="mobile-filters">
			<template #prepend>
				<div class="mobile-filters__header">
					<div class="mobile-filters__header-exit"></div>
					<div class="mobile-filters__header-title">{{ $t('modules.cars_module.filters.modal_mobile.filters') }}</div>
					<div class="mobile-filters__header-exit mobile-filters__header-exit--icon" @click="closeDrawer">
						<GlobalIcon :height="32" name="close-circle"></GlobalIcon>
					</div>
				</div>
			</template>
			<div class="mobile-filters__main">
				<div class="mobile-filters__container">
					<CarsFiltersModalMobileSingleFilter v-for="(filter, i) in filtersData" :key="i" :filter="filter" />
				</div>

				<div class="mobile-filters__buttons">
					<ButtonSecondary
						:disabled="!carsStore.getCurrentFilters?.length && !carsStore.getCurrentGroups?.length && !carsStore.getCurrentPriceRange"
						@click="clearFilters()"
						>{{ $t('modules.cars_module.filters.modal_mobile.clear') }}</ButtonSecondary
					>
					<ButtonPrimary :loading="carsStore.getCarsLoading" @click="isModalOpen = false"
						>{{ $t('modules.cars_module.filters.modal_mobile.show_results') }} ({{ carsStore.getFilteredCars?.length }})</ButtonPrimary
					>
				</div>
			</div>
		</v-navigation-drawer>
	</v-layout>
</template>

<script setup lang="ts">
import type { ISingleFilterProps } from './SingleFilter/SingleFilter.vue'

const isModalOpen = inject<Ref<boolean>>('isFiltersModalOpen')!
const carsStore = useCarsStore()

const closeDrawer = () => {
	isModalOpen.value = false
}

const clearFilters = () => {
	carsStore.clearFilters()
	isModalOpen.value = false
}

watch(
	() => isModalOpen.value,
	() => {
		if (isModalOpen.value) {
			document.body.style.overflow = 'hidden'
		} else {
			document.body.style.overflow = 'auto'
		}
	},
)

const filtersData: ISingleFilterProps[] = [
	{
		title: 'vehicle_category',
		filterName: EFilterNames.GROUP,
	},
	// {
	// 	title: 'sort',
	// 	filterName: EFilterNames.SORT,
	// 	items: [
	// 		{ name: 'most_popular', value: ESortValues.MOST_POPULAR },
	// 		{ name: 'price_asc', value: ESortValues.PRICE_ASC },
	// 		{ name: 'price_desc', value: ESortValues.PRICE_DESC },
	// 	],
	// 	isSort: true,
	// },
	{
		title: 'transmission',
		filterName: EFilterNames.TRANSMISSION,
		items: [
			{ name: 'automatic', value: 'automatic' },
			{ name: 'manual', value: 'manual' },
		],
	},
	{
		title: 'number_of_seats',
		isSeats: true,
		filterName: EFilterNames.SEATS,
	},
	{
		title: 'engine',
		filterName: EFilterNames.FUEL_TYPE,
	},
]
</script>

<style lang="scss">
@import './ModalMobile';
</style>
